import Vue from 'vue';

// Coarse pointer = phone/tablet; a laptop with a touchscreen still reports "fine" while a mouse is attached.
const device = Vue.observable({
  isTouchDevice: typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0,
});

if (typeof window !== 'undefined' && window.matchMedia) {
  const mql = window.matchMedia('(pointer: coarse)');

  device.isTouchDevice = mql.matches;

  const onChange = (event) => {
    device.isTouchDevice = event.matches;
  };

  if (mql.addEventListener) {
    mql.addEventListener('change', onChange);
  } else {
    mql.addListener(onChange);
  }
}

export { device };

export default {
  computed: {
    isTouchDevice() {
      return device.isTouchDevice;
    },
    // Items flagged touchOnly (scan in/out) are hidden on desktop
    visibleNavigation() {
      return this.navigation.filter((item) => !item.touchOnly || this.isTouchDevice);
    },
  },
};
